import { createSlice } from "@reduxjs/toolkit";

import { fetchProposalNotifications } from "./actions";

const DEFAULT_ERROR = "Failed to load notifications";

const proposalNotificationsWidgetSlice = createSlice({
  name: "proposalNotificationsWidget",
  initialState: { data: null, isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProposalNotifications.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProposalNotifications.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchProposalNotifications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default proposalNotificationsWidgetSlice.reducer;
